import {
    FaJava,
    FaPython,
    FaAws,
    FaReact,
    FaGithub,
    FaUnity,
} from "react-icons/fa";
import {
    DiMongodb,
    DiMysql,
    DiPostgresql,
    DiFirebase,
    DiHeroku,
    DiJira,
    DiIonic,
    DiUbuntu,
    DiEclipse,
    DiDotnet,
} from "react-icons/di";
import { SiSpringboot, SiJavascript, SiPostman, SiJetbrains, SiTypescript, SiDotnet } from "react-icons/si";
import { IoScanCircleSharp } from "react-icons/io5";
const IonosIcon = () => (
    <img
        src="/ionos.svg"
        alt="IONOS"
        style={{
            backgroundColor: "var(--accent-2)",
            borderRadius: "0.2em",
            width: "1em",
            height: "1em",
            objectFit: "contain"
        }}
    />
);
// Personal identity — name and contact details stay the same
// across languages/themes.
export const personal = {
    name: "Omar Hamsho",
    initials: "OH",
    email: "hamshoitsolution@gmail.com",
    phone: "+4917673829260",
};

// Technology / tool names are proper nouns and are not translated.
export const skillGroups = [
    {
        id: "frameworks",
        items: [
            { icon: SiSpringboot, name: "Spring Boot" },
            { icon: FaJava, name: "Java" },
            { icon: SiJavascript, name: "JavaScript" },
            { icon: SiTypescript, name: "TypeScript" },
            { icon: FaReact, name: "React" },
            { icon: FaPython, name: "Python" },
            { icon: SiDotnet, name: "C#" }
        ],
    },
    {
        id: "databases",
        items: [
            { icon: DiMongodb, name: "MongoDB" },
            { icon: DiMysql, name: "MySQL" },
            { icon: DiPostgresql, name: "PostgreSQL" },
            { icon: DiFirebase, name: "Firebase" },
        ],
    },
    {
        id: "tools",
        items: [

            { icon: IonosIcon, name: "IONOS" },
            { icon: FaAws, name: "AWS" },
            { icon: DiUbuntu, name: "Ubuntu" },
            { icon: FaGithub, name: "GitHub" },
            { icon: SiPostman, name: "Postman" },
            { icon: DiEclipse, name: "Eclipse" },
            { icon: SiJetbrains, name: "JetBrains" },
            { icon: DiJira, name: "Jira" },
            { icon: FaUnity, name: "Unity" },
        ],
    },
];

// Dates / "current" flags / images stay fixed; role, company and place
// text is translated (see src/i18n/translations.js, keyed by these ids).
export const experienceMeta = [
    { id: "cwsm", date: "Sep 2024 – Present", current: true },
    { id: "sourcecode", date: "2022 – 2024" },
    { id: "university", date: "2022" },
    { id: "freelancer", date: "2020 – 2022" },
];

export const educationMeta = [
    { id: "bachelor", date: "2016 – 2022" },
    { id: "unicef", date: "2019" },
    { id: "german", date: "2026" },

];

export const projectsMeta = [
    {
        id: "cwsm",
        image: "cwsm.png",
        link: "https://www.cwsm.net/",
    },
    {
        id: "rehla",
        image: "rehla.png",
    },
    {
        id: "sourcecode",
        image: "sourcecodesyr_logo.jpg",
    },
];